import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiPlus, FiEdit2, FiTrash2, FiHome, FiImage } from "react-icons/fi";
import collegeService from "../../services/collegeService";

export default function CollegeList() {
    const navigate = useNavigate();
    const [colleges, setColleges] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        collegeService
            .getAll()
            .then((res) => setColleges(res.data?.data ?? res.data ?? []))
            .catch((err) => toast.error(err.response?.data?.message || err.message))
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const handleDelete = async (college) => {
        if (!window.confirm(`Delete "${college.name}"? This only works if it has no students or employees.`)) return;
        try {
            await collegeService.remove(college._id);
            toast.success("College deleted");
            load();
        } catch (err) {
            toast.error(err.response?.data?.message || err.message);
        }
    };

    if (loading) return <div className="loading-center"><div className="spinner" />Loading colleges…</div>;

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title"><FiHome size={20} style={{ marginRight: 8, verticalAlign: -3 }} />Colleges</h1>
                    <p className="page-subtitle">{colleges.length} college{colleges.length !== 1 ? "s" : ""} under CIGOI</p>
                </div>
                <button className="btn btn-primary" onClick={() => navigate("/colleges/new")}>
                    <FiPlus size={14} /> Add College
                </button>
            </div>

            {colleges.length === 0 ? (
                <div className="card">
                    <div className="card-body" style={{ textAlign: "center", color: "var(--text-muted)", padding: "2rem" }}>
                        No colleges added yet.
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Institution &amp; Sanstha</th>
                                    <th>Code</th>
                                    <th>Discipline</th>
                                    <th>City</th>
                                    <th>Status</th>
                                    <th style={{ textAlign: "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {colleges.map((c) => {
                                    const logoUrl = c.logo?.url || (typeof c.logo === "string" ? c.logo : "");
                                    return (
                                        <tr key={c._id}>
                                            <td>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <div style={{
                                                        width: 38,
                                                        height: 38,
                                                        borderRadius: "8px",
                                                        background: "var(--bg, #f1f5f9)",
                                                        border: "1px solid var(--border, #e2e8f0)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        overflow: "hidden",
                                                        flexShrink: 0
                                                    }}>
                                                        {logoUrl ? (
                                                            <img src={logoUrl} alt={c.name} style={{ width: "100%", height: "100%", objectFit: "contain", padding: 2 }} />
                                                        ) : (
                                                            <FiImage size={18} style={{ color: "var(--text-muted, #94a3b8)" }} />
                                                        )}
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 700, color: "var(--text, #0f172a)" }}>{c.name}</div>
                                                        {c.sansthaName && (
                                                            <div style={{ fontSize: 11, color: "var(--text-muted, #64748b)", marginTop: 1 }}>
                                                                {c.sansthaName}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                            <td><span className="badge badge-info" style={{ fontWeight: 700, fontFamily: "monospace" }}>{c.code}</span></td>
                                            <td>{c.discipline}</td>
                                            <td>{c.city || "—"}</td>
                                            <td>
                                                <span style={{
                                                    fontSize: 11.5, fontWeight: 600, padding: "2px 8px", borderRadius: 99,
                                                    background: c.isActive ? "#dcfce7" : "#f1f5f9",
                                                    color: c.isActive ? "#15803d" : "#64748b",
                                                }}>
                                                    {c.isActive ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <button className="btn btn-outline btn-sm" onClick={() => navigate(`/colleges/${c._id}/edit`)} style={{ marginRight: 6 }}>
                                                    <FiEdit2 size={12} /> Edit
                                                </button>
                                                <button className="btn btn-outline btn-sm" onClick={() => handleDelete(c)} style={{ color: "#dc2626" }}>
                                                    <FiTrash2 size={12} /> Delete
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}